import dayjs from "dayjs";
import moment from "moment";

export const TimeRenderer = ({ value, showTime = true }) => {
  if (!value) return "";

  // Force UTC interpretation
  const utcDate = new Date(value + 'Z');

  if (isNaN(utcDate.getTime())) return value; // Invalid date fallback
  
  const localFormatted = moment.utc(utcDate).local().format('MM-DD-YYYY hh:mm:ss A');
  return localFormatted;

  };